
import { Component, Vue, Prop } from "vue-property-decorator";
import { Settings, TenantSettings } from "@shared/core/services/configService";
import { Format } from "@shared/core/helpers/formatHelper";
import store from "../../../shared/core/store";
import { CrudService } from "../../../shared/core/services/crudService";
import MenuShopCart from "../../../shared/components/menuShopCart/menuShopCart.vue";


@Component({
  components: {MenuShopCart},
})
export default class FooterMobile extends Vue {
  @Prop({ default: false }) settings!: TenantSettings;



  private customerQrCode: {
    content: string;
    contentType: string;
    encoding: string;
  } | null = null;
  
  private customerQrCodeTimeout: number | null = null;
  
  private get customerQrCodeImgSrc() {
    if (this.customerQrCode) {
      return `data:${this.customerQrCode.contentType};${
        this.customerQrCode.encoding
      },${this.customerQrCode.content}`;
    }
    return "";
  }

  private get displayAccessCode() {
    return (
      store.state.loggedIn === true &&
      store.state.settings.AccessControl === true
    );
  }

  goToHome() {
    this.$router.push("/");
  }

  getAddressMaps(coords: any) {
    if (Format.IsNull(coords)) {
      return "#";
    }
    const splited = coords.split(",");
    if (splited.length !== 2) {
      return "#";
    }
    return "https://www.google.com/maps/place/" + splited[0] + "," + splited[1];
  }

  getPhone(phone: string | null | undefined){
    if (Format.IsNull(phone)) {
      return "#";
    }
    return `tel:${phone}`;
  }

  private async getCustomerQrCode() {
    let url = `${Settings.HostName}/api/publicaccesscontrol/qr`;
    const res = await new CrudService().httpGet(url);
    if (!res || !res.model) {
      console.error("Crash getting customer qr code");
      return;
    }
    this.customerQrCode = {
      content: res.model.content,
      contentType: res.model.contentType,
      encoding: res.model.encoding,
    };
    const validUntil = new Date(res.model.validUntil);
    const remainigTime = validUntil.getTime() - new Date().getTime();
    this.customerQrCodeTimeout = setTimeout(
      this.getCustomerQrCode,
      remainigTime
    );
  }

  private closeQrCode() {
    this.customerQrCode = null;
    if (this.customerQrCodeTimeout) {
      clearTimeout(this.customerQrCodeTimeout);
      this.customerQrCodeTimeout = null;
    }
  }
}
